import { isEmpty } from 'ramda'
import React, { useState } from 'react'
import Link from 'next/link'
import { useQuery } from 'react-query'
import { Pagination } from 'components/elements'
import { withSizes } from 'components/helpers'
import { getCloudFlareImgVariant } from 'components/helpers/withSizes'

import { loadPeople } from '../../modules/datasource'

import * as S from './SearchPeople.styles'

const defaultProps = {}
const propTypes = {}

export const SearchPeople = ({ q, changePage, crrPage, isMobile }) => {
  const [listState, setListState] = useState([])

  const { isLoading } = useQuery(
    ['people', { q, crrPage }],
    () => loadPeople({ name: q, page: crrPage }),
    {
      fetchPolicy: 'no-cache',
      onSuccess: setListState,
    }
  )
  const { list = [], total } = listState

  return (
    <S.Container>
      <S.UserList>
        {list?.map(({ singleLineStatement, username, profileImage }) => {
          const authorPath = `/p/${username}`
          return (
            <Link href={authorPath} key={`people-${username}`} passHref>
              <S.UserProfile>
                {profileImage ? (
                  <S.AuthorPic
                    src={getCloudFlareImgVariant(profileImage, {
                      default: 'profileSmall',
                    })}
                  />
                ) : (
                  <S.AuthorPlaceholder>
                    {(username || '')[0]}
                  </S.AuthorPlaceholder>
                )}
                <S.UserInfo>
                  <S.UserName>{username}</S.UserName>
                  <S.UserDesc>{singleLineStatement}</S.UserDesc>
                </S.UserInfo>
              </S.UserProfile>
            </Link>
          )
        })}
      </S.UserList>
      {!isLoading && isEmpty(list) && (
        <S.EmptyMessage>No users found</S.EmptyMessage>
      )}
      {Math.ceil(total / 20) > 1 && (
        <Pagination
          style={{ marginTop: 32 }}
          count={Math.ceil(total / 20)}
          size={isMobile ? 'small' : 'medium'}
          color="primary"
          page={crrPage}
          onChange={(_, v) => {
            changePage(v)
            window?.scroll(0, 0)
          }}
        />
      )}
    </S.Container>
  )
}

SearchPeople.defaultProps = defaultProps
SearchPeople.propTypes = propTypes

export default withSizes(SearchPeople)
